import React, { useContext, useState } from "react";
import { IUserSolution } from "../../services/WebApiClient";
import { EditorContext } from "../EditorCommon/EditorContext";
import { LoginContext } from "../EditorCommon/LoginContext";
import { LoginModal } from "../EditorCommon/LoginModal";
import { SaveModal } from "../EditorCommon/SaveModal";
import { SaveSuccessModal } from "../EditorCommon/SaveSuccessModal";



export function SaveButton(props: {}) {
    const loginContext = useContext(LoginContext);

    const ec = useContext(EditorContext);

    const [activeModal, setActiveModal] = useState<
        { s: "none" }
        | { s: "login" }
        | { s: "save" }
        | { s: "success", userSolution: IUserSolution }
        >({ s: "none" });

    function click() {
        const newModal = loginContext.loginService.currentUser
            ? "save"
            : "login";
        setActiveModal({ s: newModal });
    }

    function closeModal() { setActiveModal({ s: "none" }); }

    function onLoggedIn() { setActiveModal({ s: "save" }); }

    function onSaved(userSolution: IUserSolution) {
        setActiveModal({
            s: "success",
            userSolution
        });
    }

    let modal;
    if (activeModal.s === "login") {
        modal = <LoginModal onClose={closeModal} onLoggedIn={onLoggedIn} />;
    }
    else if (activeModal.s === "save") {
        modal = <SaveModal onClose={closeModal} onSaved={onSaved} errorFlags={ec.cabinetService.getErrorFlags()} />;
    }
    else if (activeModal.s === "success") {
        modal = <SaveSuccessModal onClose={closeModal} userSolution={activeModal.userSolution} />
    }
    else {
        modal = undefined;
    }

    return (
        <>
            <button className="btn btn-primary" onClick={click}>
                {ec.translator("saveButton text", "Gem løsning")}
            </button>

            {modal}
        </>
    );
}

